import { generateAvatarInitialsImage, IColumn } from '@repo/ui';

export const formatDate = (date?: string) =>
  date
    ? new Intl.DateTimeFormat('pt-BR').format(new Date(`${date}T00:00:00`))
    : '-';

export const makeSuspectedActivitiesColumns = (): IColumn[] => {
  return [
    {
      title: 'Estudantes',
      dataKey: 'student',
      width: 260,
      cellRenderer: ({ rowData }) => {
        const studentName = rowData.studentName || '-';
        const fallbackAvatar = generateAvatarInitialsImage(studentName, 40);

        return (
          <div className="d-flex align-items-center gap-3 py-2">
            <img
              src={rowData.studentPhoto || fallbackAvatar}
              alt={studentName}
              style={{
                width: '38px',
                height: '38px',
                borderRadius: '999px',
                objectFit: 'cover',
                flexShrink: 0,
              }}
            />

            <div className="d-flex flex-column text-wrap">
              <div className="fw-semibold text-body">{studentName}</div>

              <div className="text-muted small">
                {rowData.institutionName || '-'}
                {rowData.courseName && ` · ${rowData.courseName}`}
              </div>
            </div>
          </div>
        );
      },
    },
    {
      title: 'Data',
      dataKey: 'date',
      cellRenderer: ({ rowData }) => {
        return <span>{formatDate(rowData?.date)}</span>;
      },
    },
    {
      title: 'Horário',
      dataKey: 'time',
    },
    {
      title: 'Locais de Estágio',
      dataKey: 'internshipLocationName',
      width: 260,
      cellRenderer: ({ rowData }) => {
        return (
          <span className="text-wrap">
            {rowData?.internshipLocationName || '-'}
          </span>
        );
      },
    },
    {
      title: 'Detectado em',
      dataKey: 'detectedAt',
    },
  ];
};
